import React, { useEffect, useState } from "react";
import { IoClose } from "react-icons/io5";
import { prductData } from "../Data";

const DemoModal = ({ isOpen, onClose, preselectedProduct = "" }) => {
  const [render, setRender] = useState(isOpen);
  const [animate, setAnimate] = useState(false);
  const [toast, setToast] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState("");

  useEffect(() => {
    if (isOpen) {
      setRender(true);
      setTimeout(() => setAnimate(true), 10);
      setSelectedProduct(preselectedProduct);
    } else {
      setAnimate(false);
      setTimeout(() => setRender(false), 300);
    }
  }, [isOpen]);

  // block scroll when modal is open
  useEffect(() => {
    if (render) {
      document.body.style.overflow = "hidden";
      document.documentElement.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "unset";
      document.documentElement.style.overflow = "unset";
    }
    return () => {
      document.body.style.overflow = "unset";
      document.documentElement.style.overflow = "unset";
    };
  }, [render]);

  const handleClose = () => {
    setAnimate(false);
    setTimeout(() => onClose(), 300);
  };

  if (!render) return null;

  return (
    <>
      {/* Toast Notification */}
      <div
        className={`fixed top-10 left-1/2 -translate-x-1/2 z-[11000] bg-green-600 text-white px-6 py-3 rounded-xl shadow-2xl transition-all duration-500 flex items-center gap-2 ${
          toast ? "opacity-100 translate-y-0" : "opacity-0 -translate-y-10 pointer-events-none"
        }`}
      >
        <svg className="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M5 13l4 4L19 7" />
        </svg>
        <p className="font-bold text-sm tracking-wide">Demo request sent successfully!</p>
      </div>

      <div className="fixed inset-0 z-[10000] flex items-end sm:items-center justify-center">
        {/* overlay */}
        <div
          className={`absolute inset-0 bg-slate-900/60 backdrop-blur-sm transition-opacity duration-300 ${
            animate ? "opacity-100" : "opacity-0"
          }`}
          onClick={handleClose}
        />

        {/* modal container */}
        <div
          className={`relative w-full sm:max-w-xl bg-white sm:rounded-2xl rounded-t-2xl shadow-2xl flex flex-col max-h-[92dvh] overflow-y-auto transition-all duration-300 ease-out ${
            animate
              ? "translate-y-0 opacity-100"
              : "translate-y-[100%] sm:translate-y-12 sm:opacity-0"
          }`}
        >
          {/* header */}
          <div className="sticky top-0 z-10 flex items-center justify-between px-5 py-4 bg-white border-b border-slate-100">
            <div>
              <span className="text-blue-600 font-bold text-[9px] uppercase tracking-[3px] block">
                Get Started
              </span>
              <h2 className="text-xl font-teko uppercase text-slate-900 leading-none">
                Request a Demo
              </h2>
              <p className="text-slate-500 text-[11px] mt-1">
              Experience our advanced software solutions firsthand. Fill in your details and we'll reach out.
            </p>
            </div>
            <button
              onClick={handleClose}
              className="p-2 rounded-full bg-slate-100 text-slate-500 hover:bg-slate-200 hover:text-slate-800 transition-colors"
              aria-label="Close modal"
            >
              <IoClose size={18} />
            </button>
          </div>

          {/* body */}
          <div className="p-5 flex-1">

            <form
              className="space-y-3"
              onSubmit={(e) => {
                e.preventDefault();
                setToast(true);
                setTimeout(() => {
                  setToast(false);
                  handleClose();
                }, 2500);
              }}
            >
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                <div className="space-y-0.5">
                  <label className="text-[9px] font-bold text-slate-400 uppercase tracking-wider ml-1">
                    Name
                  </label>
                  <input
                    type="text"
                    required
                    placeholder="Full Name"
                    className="w-full px-4 py-2.5 bg-slate-50 border border-slate-200 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-500/20 focus:border-blue-500 transition-all"
                  />
                </div>
                <div className="space-y-0.5">
                  <label className="text-[9px] font-bold text-slate-400 uppercase tracking-wider ml-1">
                    Contact No.
                  </label>
                  <input
                    type="tel"
                    required
                    placeholder="Phone Number"
                    className="w-full px-4 py-2.5 bg-slate-50 border border-slate-200 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-500/20 focus:border-blue-500 transition-all"
                  />
                </div>
              </div>

              <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                <div className="space-y-0.5">
                  <label className="text-[9px] font-bold text-slate-400 uppercase tracking-wider ml-1">
                    Email
                  </label>
                  <input
                    type="email"
                    required
                    placeholder="abc@gmail.com"
                    className="w-full px-4 py-2.5 bg-slate-50 border border-slate-200 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-500/20 focus:border-blue-500 transition-all"
                  />
                </div>
                <div className="space-y-0.5">
                  <label className="text-[9px] font-bold text-slate-400 uppercase tracking-wider ml-1">
                    Company
                  </label>
                  <input
                    type="text"
                    required
                    placeholder="Company Name"
                    className="w-full px-4 py-2.5 bg-slate-50 border border-slate-200 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-500/20 focus:border-blue-500 transition-all"
                  />
                </div>
              </div>

              <div className="space-y-0.5">
                <label className="text-[9px] font-bold text-slate-400 uppercase tracking-wider ml-1">
                  Address
                </label>
                <input
                  type="text"
                  required
                  placeholder="Street, City, State"
                  className="w-full px-4 py-2.5 bg-slate-50 border border-slate-200 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-500/20 focus:border-blue-500 transition-all"
                />
              </div>

              <div className="grid grid-cols-3 gap-2 sm:gap-3">
                <div className="space-y-0.5">
                  <label className="text-[9px] font-bold text-slate-400 uppercase tracking-wider ml-1">
                    Date
                  </label>
                  <input
                    type="date"
                    required
                    className="w-full px-2 py-2.5 bg-slate-50 border border-slate-200 rounded-lg text-[11px] focus:outline-none focus:ring-2 focus:ring-blue-500/20 focus:border-blue-500 transition-all"
                  />
                </div>
                <div className="space-y-0.5">
                  <label className="text-[9px] font-bold text-slate-400 uppercase tracking-wider ml-1">
                    Time
                  </label>
                  <input
                    type="time"
                    required
                    className="w-full px-2 py-2.5 bg-slate-50 border border-slate-200 rounded-lg text-[11px] focus:outline-none focus:ring-2 focus:ring-blue-500/20 focus:border-blue-500 transition-all"
                  />
                </div>
                <div className="space-y-0.5">
                  <label className="text-[9px] font-bold text-slate-400 uppercase tracking-wider ml-1">
                    Product
                  </label>
                  <select
                    required
                    value={selectedProduct}
                    onChange={(e) => setSelectedProduct(e.target.value)}
                    className="w-full px-2 py-2.5 bg-slate-50 border border-slate-200 rounded-lg text-[11px] focus:outline-none focus:ring-2 focus:ring-blue-500/20 focus:border-blue-500 transition-all appearance-none cursor-pointer"
                  >
                    <option value="">Select</option>
                    {prductData.map((product) => (
                      <option key={product.id} value={product.title}>
                        {product.title}
                      </option>
                    ))}
                  </select>
                </div>
              </div>

              <div className="space-y-0.5">
                <label className="text-[9px] font-bold text-slate-400 uppercase tracking-wider ml-1">
                  Comments (Optional)
                </label>
                <textarea
                  rows="2"
                  placeholder="Specific requirements or questions?"
                  className="w-full px-4 py-2.5 bg-slate-50 border border-slate-200 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-500/20 focus:border-blue-500 transition-all resize-none"
                />
              </div>

              <button
                type="submit"
                className="w-full mt-1 py-3.5 bg-blue-600 hover:bg-blue-700 active:bg-blue-800 text-white rounded-xl font-bold uppercase tracking-widest text-[11px] transition-all shadow-lg shadow-blue-200 active:scale-[0.98]"
              >
                Submit Demo Request
              </button>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default DemoModal;
